import { SvgIcon } from '@mui/material';

const MeatIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="17"
        height="16"
        viewBox="0 0 17 16"
        fill="none"
      >
        <path
          d="m6.734 10.998-1.45 1.45c.216.251.34.57.35.9a1.3 1.3 0 0 1-1.3 1.25 1.25 1.25 0 0 1-1.25-1.25 1.25 1.25 0 0 1-1.25-1.25 1.3 1.3 0 0 1 1.25-1.3c.331.01.649.134.9.35l1.45-1.45m8.001-6.7.75.75a2.6 2.6 0 0 1 0 3.65l-.3.3a11.4 11.4 0 0 1-5 2.85l-2.1.5-.7-.7-.7-.7.55-2.1a10.35 10.35 0 0 1 2.85-4.95l.3-.35a2.6 2.6 0 0 1 3.65 0z"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </SvgIcon>
  );
};

export default MeatIcon;
